import { render, staticRenderFns } from "./login-as.vue?vue&type=template&id=94917958&"
import script from "./login-as.vue?vue&type=script&lang=js&"
export * from "./login-as.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports